import script from "./ResistanceExternal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResistanceExternal.vue?vue&type=script&setup=true&lang=ts"

import "./ResistanceExternal.vue?vue&type=style&index=0&id=ef3e90e2&lang=scss"

const __exports__ = script;

export default __exports__